export const menuEn = {
  alerts: 'Alerts',
  analytics: 'Analytics',
  antifraud: 'Antifraud',
  invoice: 'Invoice',
  list: 'List',
  logout: 'Log out',
  makecredit: 'Withdraw',
  payments: 'Payments',
  reports: 'Reports',
  sbpLink: 'Payouts',
  sbpTitle: 'FPS',
  sbpPaymentsTitle: 'FPS payments',
  sbpPayoutsTitle: 'FPS payouts',
  sbpPaymentsLink: 'Payments',
  makeFasterPayout: 'Make a payout',
  apmTitle: 'APM',
  apmLink: 'Payouts',
  apmPaymentsLink: 'Payments',
  settings: 'Settings',
  withdrawals: 'Withdrawals',
  account: 'Account',
  payment: 'Payment',
  notifications: 'Notifications',
  users: 'Users',
  cryptoPaymentsTitle: 'Crypto payments',
  cryptoPaymentsLink: 'Crypto payments',
  returns: 'Returns',
  makeReturn: 'Make a return',
} as const;

type TMenuEnKeys = keyof typeof menuEn;

export const menuRu = {
  alerts: 'Оповещения',
  analytics: 'Аналитика',
  antifraud: 'Антифрод',
  invoice: 'Выставить счет',
  list: 'Список',
  logout: 'Выйти',
  makecredit: 'Сделать выплату',
  payments: 'Платежи',
  reports: 'Отчеты',
  sbpLink: 'Выплаты',
  sbpTitle: 'СБП',
  sbpPaymentsTitle: 'СБП платежи',
  sbpPayoutsTitle: 'СБП выплаты',
  sbpPaymentsLink: 'Платежи',
  makeFasterPayout: 'Сделать выплату',
  apmTitle: 'APM',
  apmLink: 'Выплаты',
  apmPaymentsLink: 'Платежи',
  settings: 'Настройки',
  withdrawals: 'Выплаты',
  account: 'Аккаунт',
  payment: 'Оплата',
  notifications: 'Уведомления',
  users: 'Пользователи',
  cryptoPaymentsTitle: 'Crypto платежи',
  cryptoPaymentsLink: 'Crypto платежи',
  returns: 'Возвраты',
  makeReturn: 'Сделать возврат',
} satisfies Record<TMenuEnKeys, string>;
